<script lang="ts">
	import { onDestroy, onMount } from 'svelte'
	import createCustomMarkerClass from '$lib/map/CustomMarker'

	// Create type for CustomMarker instance
	type CustomMarkerType = InstanceType<ReturnType<typeof createCustomMarkerClass>>

	interface Props {
		latitude: number
		longitude: number
		isActive?: boolean
		map: google.maps.Map
		isVisable?: boolean
		children?: import('svelte').Snippet
	}

	let { latitude, longitude, isActive = false, map, isVisable = true, children }: Props = $props()

	let markerComponent: HTMLDivElement | null = $state(null)
	let marker: CustomMarkerType | null = null

	onMount(async () => {
		if (!window.google || !markerComponent || !map) return

		try {
			const CustomMarker = createCustomMarkerClass()

			marker = new CustomMarker(markerComponent, map, {
				lat: latitude,
				lng: longitude,
			})
		} catch (error) {
			console.error('Error creating marker:', error)
		}
	})

	onDestroy(() => {
		if (marker) {
			marker.remove()
		}
		if (markerComponent?.parentElement) {
			markerComponent.parentElement.removeChild(markerComponent)
		}
	})
</script>

<div
	bind:this={markerComponent}
	class={`hover:z-50 ${isActive ? 'z-40' : 'z-10'} ${isVisable ? 'block' : 'hidden'}`}
>
	<div
		class={`hover:scale-125 hover:-translate-y-1 scale-100 transition-all text-sm font-medium ${
			isActive ? 'z-40 scale-125 -translate-y-1' : 'z-10'
		}`}
	>
		{@render children?.()}
	</div>
</div>
